var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZigZag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_768_2708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0114 4.34766L9.67806 10.681L6.34473 7.34766L1.34473 12.3477M16.0114 4.34766H12.0114M16.0114 4.34766L16.0114 8.34766",
    stroke: "#249CFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_768_2708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.677734 0.347656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZigZag);
export default __webpack_public_path__ + "static/media/zig-zag.f89242955872e5435c515b7404d2fa12.svg";
export { ForwardRef as ReactComponent };